(function () {
  var SCROLLING_CLASS = 'announcement-ticker--scrolling';
  var CLONE_ATTR = 'data-ticker-clone';
  var GAP_PX = 60;
  var PX_PER_SECOND = 60;

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function measure(frame) {
    var scale = frame.querySelector('[data-ticker-scale]');
    var text = frame.querySelector('[data-ticker-text]');
    if (!scale || !text) return;

    var existingClone = scale.querySelector('[' + CLONE_ATTR + ']');
    if (existingClone) existingClone.parentNode.removeChild(existingClone);
    scale.classList.remove(SCROLLING_CLASS);
    scale.style.removeProperty('--ticker-distance');
    scale.style.removeProperty('--ticker-duration');

    if (prefersReducedMotion()) return;

    var frameStyle = window.getComputedStyle(frame);
    var horizontalPadding =
      parseFloat(frameStyle.paddingLeft || 0) +
      parseFloat(frameStyle.paddingRight || 0);
    var available = frame.clientWidth - horizontalPadding;
    var needed = text.scrollWidth;

    if (needed <= available) return;

    var clone = text.cloneNode(true);
    clone.setAttribute(CLONE_ATTR, '');
    clone.setAttribute('aria-hidden', 'true');
    scale.appendChild(clone);

    var distance = needed + GAP_PX;
    var duration = distance / PX_PER_SECOND;

    scale.style.setProperty('--ticker-distance', '-' + distance + 'px');
    scale.style.setProperty('--ticker-duration', duration + 's');
    scale.classList.add(SCROLLING_CLASS);
  }

  function init() {
    var frames = document.querySelectorAll(
      '.announcement__bar-holder--slider [data-ticker-frame]'
    );
    if (!frames.length) return;

    frames.forEach(measure);

    var remeasure = debounce(function () {
      frames.forEach(measure);
    }, 150);

    document.addEventListener('theme:resize', remeasure);
    window.addEventListener('resize', remeasure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
